export default __webpack_public_path__ + "static/media/ganges.92e32275.webp";